import { RendererContextType } from '../../../../contexts/RendererContext';
import { GroupType, ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaSurface } from '../../../../potree/utils/PointoramaSurface';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Group = Project['state']['groups'][number];

export function createSyncSurfacesConfig({
  viewer,
  groups,
  surfacePropertiesLoading,
}: {
  viewer: NonNullable<RendererContextType['viewer']>;
  groups: Project['state']['groups'];
  surfacePropertiesLoading: boolean;
}): SyncConfig<Group, PointoramaSurface> {
  return {
    getSourceItems: () => {
      if (surfacePropertiesLoading) return null;
      return groups.filter((group) => group.type === GroupType.Surface);
    },
    getSceneItems: () => [...(viewer.scene.surfaces || [])],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    update: () => 'unchanged',
    create: (source) => {
      const surface = new PointoramaSurface({
        identifier: source.identifier,
      });
      surface.finished = true;
      return surface;
    },
    addToScene: (item) => viewer.scene.addSurface(item),
    removeFromScene: (item) => viewer.scene.removeSurface(item),
  };
}
